import NavBarLogo from "./logo.navBar";
import { Link, useParams } from "react-router-dom";

const CLASSNAMES = {
  link: "hover:underline hover:text-primary cursor-pointer",
};

const NavBar = () => {
  const { category, make, model } = useParams();
  return (
    <nav className="flex-col backdrop-blur-sm shadow-md shadow-secondary bg-whiteGlass z-[1000] text-3xl fixed flex justify-center w-screen py-2 border-b border-black">
      <NavBarLogo />
      <div className="flex flex-row justify-center gap-8">
        <Link to="/" className={CLASSNAMES.link}>
          Home
        </Link>
        {make && make !== "apple" && (
          <Link to={`/${category}`} className={CLASSNAMES.link}>
            Makes
          </Link>
        )}
        {model && (
          <Link to={`/${category}/${make}`} className={CLASSNAMES.link}>
            Models
          </Link>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
